import { Component, ContentChildren, QueryList, AfterContentInit, AfterViewInit, ViewChild, HostListener } from '@angular/core';

import { TabComponent } from '../tab/tab.component';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'da-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    standalone: false
})
export class TabsComponent implements AfterContentInit, AfterViewInit {
    private _showActionElements: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _disabledButton: BehaviorSubject<{ left: boolean; right: boolean }> = new BehaviorSubject({
        left: true,
        right: false
    });

    @ContentChildren(TabComponent) tabComponent: QueryList<TabComponent>;
    @ViewChild('tabs', { static: true }) tabs;
    @ViewChild('nav', { static: true }) nav;

    @HostListener('window:resize')
    resizeBy() {
        this._calculateState();
    }

    @HostListener('scroll')
    onElementScroll() {
        this._calculateState();
    }

    constructor() {}

    // contentChildren are set
    ngAfterContentInit() {
        // get all active TabComponent
        setTimeout(() => {
            const activeTabs = this.tabComponent.filter((tab) => tab.active);
            // if there is no active tab set, activate the first
            if (activeTabs.length === 0) {
                this.selectTab(this.tabComponent.first);
            }
        });
    }

    selectTab(tab: any, userInteraction?: boolean) {
        if (tab && !tab.active) {
            // deactivate all TabComponent
            this.tabComponent.toArray().forEach((item) => (item.active = false));
            // activate the tab the user has clicked on.
            tab.active = true;
        }
    }

    ngAfterViewInit(): void {
        this._calculateState();
    }

    public isNavigationActive(): BehaviorSubject<boolean> {
        return this._showActionElements;
    }

    public isDisabledButton(): BehaviorSubject<{ left: boolean; right: boolean }> {
        return this._disabledButton;
    }

    private _disabledButtonClick(): void {
        const _obj = this._disabledButton.getValue();
        const _tabsScrollLeft = this.tabs.nativeElement.scrollLeft;
        const _navOffsetWidth = this.nav.nativeElement.offsetWidth;
        const _tabsScrollWidth = this.tabs.nativeElement.scrollWidth;
        _obj.left = _tabsScrollLeft === 0;
        _obj.right = _tabsScrollLeft + _navOffsetWidth >= _tabsScrollWidth;
        this._disabledButton.next(_obj);
    }

    private _calculateState() {
        setTimeout(() => {
            this._showActionElements.next(this.nav.nativeElement.offsetWidth < this.tabs.nativeElement.scrollWidth);
            this._disabledButtonClick();
            // trigger scroll event to show images
            const e = document.createEvent('Event');
            e.initEvent('scroll', true, true);
            window.dispatchEvent(e);
        });
    }

    public focusTab(event) {
        this.tabs.nativeElement.scrollTo({
            left: event.currentTarget.offsetLeft,
            behavior: 'smooth'
        });
        this._calculateState();
    }

    public navigateRight(): void {
        this.tabs.nativeElement.scrollTo({
            left: this.tabs.nativeElement.scrollLeft + 150,
            behavior: 'smooth'
        });
    }

    public navigateLeft(): void {
        this.tabs.nativeElement.scrollTo({
            left: this.tabs.nativeElement.scrollLeft - 150,
            behavior: 'smooth'
        });
    }
}
